!function (module) {
  //>>excludeStart("requireTmpl", pragmas.requireTmpl);
  if (typeof window.define !== "undefined")
    define('flights/index',['libs/ct_routes', 'libs/ct_pers', 'libs/ct_store', 'flights/searchForm', 'common/searchTab', 'flights/searchRecent', 'common/smartHomePage', 'widgets/ct_offermgmt', 'widgets/validator', 'flights/validators', 'widgets/ct_offerbanner', 'common/currencyConverter', 'widgets/tooltip_v2', 'common/utils', 'flights/flight_utils', 'widgets/placeholder', 'libs/local_homepage', 'libs/fetchCitiesList', 'widgets/royal-slider', 'flightShortlist', 'widgets/gdprbanner'], module)
  else
    //>>excludeEnd("requireTmpl");
    module(CT.Routes, CT.Pers, CT.Store, CT.cache.views.searchForm, CT.cache.views.searchTab, CT.cache.views.searchRecent, CT.smartHomePage, CT.Offers, CT.widgets.validator, CT.settings.validators, CT.Banner)
}(function (Routes, Pers, store, searchFormView, searchTabView, recentSearchView, smartHomePageView, Offers, Validator, FormValidator, Banner) {



  /* ======================= MODULE SPECIFIC VARIABLES  =========================== */
  var _hasPushState = window.history && "pushState" in window.history;


  /* ======================= PRIVATE METHODS =========================== */
  function setMouseFlowPage(url) {
    if (typeof mouseflow !== 'undefined') {
      window.mouseflowPath = url;
      mouseflow.newPageView();
    }
  }

  // This renders personalization information on the home page after the json is received from the server - see "initPers" below
  function showPersInfo(res) {
    var pers = this;

    if (window.enableRecentSearch) {
      if (($.browser.msie && parseInt($.browser.version, 10) <= 8)) {
      } else {
        // populate recent search
        var recentPers = pers.get('recent');
        if (recentPers && (window.enableRecentSearchFlightsPageOnly && window.location.href.indexOf('/flights') > -1) || !window.enableRecentSearchFlightsPageOnly)//localfix
          recentSearchView.render(recentPers);
        else
          recentSearchView.hideRecent();

        // get user obj
				/*var user = User.getInstance()
				if (user.isLoggedIn) {
					Session.smartness(pers);
				} else {
					//Repeat confirmed user - not loyal
					Session.welcomeBack(pers);
				}*/
      }
    }
  }

  /*===============Smart Home Page start================*/
  function showSmartHomePage() {
    smartHomePageView.render();
  }

  /*===============Smart Home Page End================*/

  // This sets up the personalization when the home page loads
  function initPers(e) {
    var pers = new Pers();
    //pers.getJson('', showPersInfo);
    showPersInfo.call(pers)
  }




  function getPathName(urlData) {
    var appendFlights = (!("pushState" in window.history) && window.location.href.indexOf('/flights') === -1)
    return (appendFlights ? '/flights' : '') + (urlData.intl === 'y' ? '/international' : '') + '/results?';
  }


  function getFullPathName(urlData) {
    return '/flights' + (urlData.intl === 'y' ? '/international' : '') + '/results?';
  }



  function preInit() {

    if ($('#travelsafeStatsDiv').length) {
      CT.utils.travelStats();
    }
    //set the viewController min-height based on viewport height
    //var extraSEOHeight = Number($(".addOnFooter").innerHeight());
    var asideLeftHeight = $('#Home').find('aside').first().outerHeight(),
      asideRightHeight = $('#Home').find('aside').last().outerHeight(),
      windowHeight = $(window).outerHeight(),
      localFrameHeight = $('.localFrame').outerHeight();
    appBannerHeight = $('#homeUpsellBanner').outerHeight(),
      appBannerHeight = appBannerHeight ? appBannerHeight : '0',
      localFrameHeight = localFrameHeight ? localFrameHeight : '0';

    var height = Math.max(asideLeftHeight, asideRightHeight, windowHeight - 100 - appBannerHeight);

    var spaceViewHeight = windowHeight - ($('#GlobalNav').outerHeight() + $('footer').outerHeight() + parseInt(appBannerHeight));

    spaceViewHeight = spaceViewHeight > 910 ? spaceViewHeight : 910;

    $(".spacesView").css("min-height", spaceViewHeight + "px")


    // $('.viewController').css('min-height', height +"px");


    CT.cache.homeTitle = document.title
    CT.cache.els = {
      $homeSection: $("#Home"),
      $homeCenter: $('#Home .viewController'),
      $resultSection: $("#Result")
    };

    //$('.tipsy .close').tipsy('show');

    //initalize more option link
    $("#moreProductsLink").bind("click", function (e) {
      $(".moreProducts").toggle();
    });




    CT.widgets.validator.delegate({ errContainer: "fieldset" });

    $(document).delegate("#modifySearchLink", "click", function (e) {

      var $link = $(this), $arrow = $link.find("i");
      if ($arrow.hasClass("rArrow")) {
        $(".spacesView").addClass("modifySearch");
        CT.utils.modifySearch.open($arrow, $link);
      } else {
        $(".spacesView").removeClass("modifySearch");
        CT.utils.modifySearch.close($arrow, $link);
      }


    });
  }

  function localEvents(e) {

    if ($('#space_travel').is(':checked')) {
      $("#localFooter").css('display', 'none');
    } else if ($('#space_local').is(':checked')) {
      $("#localFooter").css('display', 'block');
    }
    $('#space_travel').on('change', function (e) {
      if (this.checked) {
        //localsHome.showTravelSpace();
        //window.localsHome.init();
        CT.settings.routes.baseUrl = "/flights";
        if (window.localsHome.cTapTrackOnSwitch) window.localsHome.cTapTrackOnSwitch('travel');
        window.localsHome.showTravelSpace();
        CT.settings.routes.navigate(window.location.protocol + "//" + window.location.hostname, { trigger: false });
        //e.stopImmediatePropagation();
        CT.utils.helperFunctions.trackGAEvent("Home", "Toggle", "Travel");
      }
      $("#localFooter").css('display', 'none');
    });
    $('.localFrame').on('click', function (e) {
      if ($('.spacesReel').hasClass("isShowingLocal") == false) {
        window.localsHome.showLocalSpace();
        CT.settings.routes.navigate(window.location.href + 'local', { trigger: false })
        e.stopImmediatePropagation();
      }
    });
    $('.travelFrame').on('click', function (e) {
      if ($('.spacesReel').hasClass("isShowingLocal")) {
        window.localsHome.showTravelSpace();
        CT.settings.routes.navigate(window.location.protocol + "//" + window.location.hostname, { trigger: false })
        e.stopImmediatePropagation();
      }
    });
    $('#space_local').on('change', function (e) {
      if (this.checked) {
        if (CT.utils.cookies.read("localCurrentCity") != null) {
          window.currentCityName = CT.utils.cookies.read("localCurrentCity");
        } else {
          window.currentCityName = "mumbai"
        }
        //window.localsHome.init(window.currentCityName.toLowerCase());
        if (window.localsHome.cTapTrackOnSwitch) window.localsHome.cTapTrackOnSwitch('local');
        window.localsHome.showLocalSpace();
        CT.settings.routes.baseUrl = ""
        CT.settings.routes.navigate('/local', { trigger: false })
        //e.stopImmediatePropagation();
        CT.utils.helperFunctions.trackGAEvent("Home", "Toggle", "Local");
      }
      $("#localFooter").css('display', 'block');
    });

    $(document).on('keydown', function (event) {
      switch (event.which) {
        case 37: // left
          if (event.target.nodeName != "INPUT" && window.location.pathname == "/local") {
            //localsHome.showTravelSpace();
            //window.localsHome.init();
            window.localsHome.showTravelSpace();
            CT.settings.routes.navigate(window.location.protocol + "//" + window.location.hostname, { trigger: false })
            //event.stopImmediatePropagation();
            CT.utils.helperFunctions.trackGAEvent("Home", "LHS", "Travel");
          }
          break;

        case 39: // right
          if (event.target.nodeName != "INPUT" && window.location.pathname == "/") {
            if (CT.utils.cookies.read("localCurrentCity") != null) {
              window.currentCityName = CT.utils.cookies.read("localCurrentCity");
            } else {
              window.currentCityName = "mumbai"
            }
            //window.localsHome.init(window.currentCityName.toLowerCase());
            window.localsHome.showLocalSpace();
            CT.settings.routes.navigate(window.location.href + 'local', { trigger: false })
            //event.stopImmediatePropagation();
            CT.utils.helperFunctions.trackGAEvent("Home", "RHS", "Local");
          }
          break;

        default: return; // exit this handler
      }
    });

    if (window.location.pathname.indexOf("local") == 1) {
      CT.utils.helperFunctions.trackGAEvent();
    }
  }


  // This initializes the app when the home page loads
  function init(e) {
    $(document.body).removeClass('srp multiCity splitScreen').addClass('home')
    //$('.searchForm').css('min-height', $(".travelFrame").outerHeight() +"px");
    checkGclId();
    if (window.enableLocalTab) {
      window.localsHome.initv2({ attachLink: true, localsLinkId: "localsNav" })
    }

    if (window.enableLocalWeb) {
      var initLocals = function () {
        window.localsHome.initv2({ 'showLocalCard': true });
        window.localsHome.cTapTrackOnLoad();
      }

      if ($.isloaded) {
        initLocals()
      } else {
        $(window).load(function () {
          initLocals()
        })
      }
    }


    if (!e || (e && !e.isPopped)) { //Search page was rendered before/at the beginning
      $('.srpOverlay,#srpOverlayWarning').hide();
      //var user = User.getInstance();
      //if(user.loggedIn) //TODO enable this in production
      if (!e)
        initPers(e)
    } else { //back button clicked from the results page (when results page was first loaded)
      document.title = CT.cache.homeTitle;
      //close modify search.
      CT.utils.modifySearch.close();
      CT.utils.modifySearch.closeLabel();
      (searchFormView || CT.cache.views.searchForm).render() // hides #Result and shows #Hoe .. i mean, #Home
			/*if(window.enableBannerAutomation){
				//CT.utils.helperFunctions.displayBanners({"page":"home","url":window.homePageBannersJson});
			}else{
				$('#homeUpsellBanner').show();
			}*/
      initPers();
    }

    CT.fire("syncFlightShortlistToAccounts");

    //GA Tag Manager Object
    if (window.countryCode == "sa") {
      dataLayer = CT.settings.GATagManager;
      dataLayer[0]['Date-Search'] = moment().format("DD/MM/YYYY");
      dataLayer[0]['Day-Search'] = moment().format("dddd");
      dataLayer[0]['Product'] = "Air";
      dataLayer[0]['Device'] = "Desktop";
    }
    //CT.utils.helperFunctions.spotNonCleartripReferrer();

    if (window.B2cProductEnabled) {
      var loadOnlyCommon = true;
      if (document.readyState == 'complete') {
        CT.utils.loadTrackers(null, loadOnlyCommon);
      } else {
        $(window).load(function () { CT.utils.loadTrackers(null, loadOnlyCommon) });
      }
    }
    CT.utils.cookies.erase("defaultHotelsPage"); //Erasing the cookie set in Hotels SRP
    //closing tipsy
    $('.tipsy .close').trigger("click");
    //setMouseFlowPage('/flights')
    // initialize offers section
    if (homePageOffersJson) {
      Offers.init({ product: 'air', page: 'home', url: homePageOffersJson });
    }
    Banner.init({ country: window.countryCode, language: window.language });
    if ((window.enableLocalWeb && !window.isHomePage) || !window.enableLocalWeb) {
      showSmartHomePage();
    }


    if (window.countryCode == "sa") {
      // reinit dataLayer, as it is possible that user is coming from search results page.
      dataLayer[0]['From-Location'] = 'Value';
      dataLayer[0]['People-No'] = 'Value';
      dataLayer[0]['To-Location'] = 'Value';
      dataLayer[0]['Travel-Dates'] = 'Value';
      dataLayer[0]['Travel-Type'] = 'Value';
      dataLayer[0]['Flight-Return-OneWay'] = 'Value';
      if (window.B2cProductEnabled) {
        CT.utils.helperFunctions.includeGATagManager();
      }
    }

    CT.utils.helperFunctions.storeUserReferer();
    if (window.countryCode == "sa") {
      CT.utils.helperFunctions.gtmMethods.setDataLayer({
        'Product': 'Air',
        'Device': 'Desktop',
        'Domain': window.countryCode,
        'Language': window.language,
        'Currency': CT.settings.countryCurrCode && CT.settings.countryCurrCode[countryCode] && CT.settings.countryCurrCode[countryCode].code,
        'Device Type': window.isMobileUA ? 'Mobile' : 'Desktop'
      }).triggerEvent('airSearchLoaded');
    }
    $(".flashSaleInfo").delegate("#flightsHomeFlashSaleBanner", "click", function () {
      CT.fire("flashsale.click");
    });
    homePageCleverTapLogger();
  }

  function homePageCleverTapLogger() {
    CT.utils.helperFunctions.tpTrack({
      category: 'cleartrip home viewed',
      tp: 'clevertap',
      values: {
        domain: window.location.hostname,
        is_logged_in: CT.utils.readCTAuthCookie() ? 'yes' : 'no',
        page_name: (window.location.pathname == '/' ? 'cleartrip' : 'flights') + "_home",
        platform: "desktop",
        source: "web"
      }
    })
  }

  function checkGclId() { //This method is called for checking google paid service
    var urlObj = _.deserialize(window.location.search.substring(1));
    if (urlObj.gclid) {
      CT.utils.cookies.create("utm_source", "googlesem", 1 / 48); //30 mins
    }
    CT.utils.helperFunctions.spotNonCleartripReferrer(undefined, window.location.href);
  }

  function _loadResultsPage(paramsHash) {
    //>>excludeStart("asyncRequireLoader", pragmas.asyncRequireLoader);
    if (window.define) {
      require(['flights/airSearchResult'], function () {
        CT.fire('results', [paramsHash])
      });
    } else
      //>>excludeEnd("asyncRequireLoader");
      if (!$.isReady)
        $(function () { //fires when DOM is ready in production
          CT.fire('results', [paramsHash]);
        })
      else
        CT.fire('results', [paramsHash]);
    $('#SearchBtn').removeClass('loading');
  }

  // This lazy loads the results page
  function loadResultsPage(paramsHash) { // paramsHash contains all the URL params + routes data
    if (!$('#SearchBtn').hasClass('formIsValid') && (paramsHash.from || paramsHash.to)) {
      var f = FormValidator.checkForCityAvailability
      $.when(f(paramsHash.from), f(paramsHash.to)).done(function (a1, a2) {
        //TODO test all use cases for a1 and a2
        if (paramsHash.from.length != 3 || paramsHash.to.length != 3) {
          if (a1[0][0] && a2[0][0]) {
            if (paramsHash.from !== a1[0][0].k || paramsHash.to !== a2[0][0].k) {
              paramsHash.from = a1[0][0].k
              paramsHash.to = a2[0][0].k
            }
          }
        }
        else {
          // iterate through all the results in a1 and a2.
          // until you get correct "from, to" key searched by the user.
          // if nothing is found fall back to the first result.
          var _a1 = a1[0], _a2 = a2[0], _f = paramsHash.from.toUpperCase(),
            _t = paramsHash.to.toUpperCase(), fromFound = false, toFound = false;
          for (var i = 0, len = _a1.length; i < len; i++) {
            if (_a1[i] && _f === _a1[i].k) {
              paramsHash.from = _a1[i].k;
              fromFound = true;
              break;
            }
          }
          for (var i = 0, len = _a2.length; i < len; i++) {
            if (_a2[i] && _t === _a2[i].k) {
              paramsHash.to = _a2[i].k;
              toFound = true;
              break;
            }
          }
          if (!fromFound)
            paramsHash.from = _a1[0] !== undefined ? _a1[0].k : paramsHash.from;
          if (!toFound)
            paramsHash.to = _a2[0] !== undefined ? _a2[0].k : paramsHash.to;
        }
        //Making it false..to be fixed later

        CT.messages[CT.app].nearByairportsMsg.pickedClosestMatch = false
        routes.navigate(window.location.href.replace(/from=[^&.]+&/, 'from=' + paramsHash.from + '&').replace(/to=[^&.]+&/, 'to=' + paramsHash.to + '&'), { trigger: false, replace: true })
        _loadResultsPage(paramsHash)
      }).fail(function () {
        routes.navigate(window.location.href.replace(/from=[^&.]+&/, 'from=' + paramsHash.from + '&').replace(/to=[^&.]+&/, 'to=' + paramsHash.to + '&'), { trigger: false, replace: true })
        _loadResultsPage(paramsHash)
      });


    } else _loadResultsPage(paramsHash)
  }



  function cleanRoutesData() {
    try {
      var a = _.deserialize(window.location[_hasPushState ? 'href' : 'hash'].split('results?')[1])
      if (!a.from && !a.from1) a = _.deserialize(window.location[_hasPushState ? 'href' : 'hash'].split('?')[1])
    } catch (e) {
      console.error(e.message)
    }

    if (a.multicity === 'true' || a.from1) {
      _.times(3, function (n) {
        n = n + 3
        if (!!a['depart_date_' + n] && (a['from' + n].length === 0 || a['to' + n].length === 0)) a['depart_date_' + n] = ''
      })
    }
    return a
  }




  function search(data) { // When called directly from address bar, data will be undefined
    var routesData = data, tmp
    CT.settings.srpRenderTime = new Date().getTime();
    function newSearchFlow(paramsHash, toRefresh) {
      var tabCheckParams = ['from', 'to', 'depart_date', 'return_date']
      CT.fire('tab.init', [paramsHash, tabCheckParams, toRefresh]); // create a new tab
      //console.log('new search flow', CT.settings.currentTab)
      loadResultsPage(paramsHash, toRefresh);
    }



    function existingSearchFlow(paramsHash) {
      $(document.body).removeClass('home').addClass('srp')[(!paramsHash.depart_date ? 'add' : 'remove') + 'Class']('multiCity splitScreen')[(paramsHash.return_date ? 'add' : 'remove') + 'Class']('splitScreen')
      $('#Home').hide(); // hide home
      $('#homeUpsellBanner').hide(); // hide home app upsell banner
      $('#Result').show(); // show result section
      $('#ResultContainer_' + CT.settings.currentTab).hide(); // hide current result container
      var tabId = searchTabView.getCurrentTab(paramsHash).tabId || ""; // get the tab id of the requested tab

      if ($('#ResultContainer_' + tabId)[0]) { // if the container is present , do a toggle for those tabs.
        var $resContainer = $('#ResultContainer_' + tabId), refresh = false
        if (!CT.cache[tabId].searchTime) {
          $resContainer.unbind().empty()/*.append($('.resultTemplate').html())*/
          refresh = true
        }
        var params = CT.cache[tabId].searchParams.all
        var isDomRT = !params.isIntl && params.isRt
        $(document.body)[(isDomRT ? 'add' : 'remove') + 'Class']('splitScreen roundTrip')
        $resContainer.css('display', 'block');
        $('#RecentTab_' + tabId.split('_')[0]).siblings().removeClass('current').end().addClass('current');
        CT.settings.currentTab = tabId;
        CT.utils.modifySearch.close();
        CT.utils.modifySearch.openLabel(params);
        $('#SearchBtn').removeClass('loading');
        document.title = CT.cache[tabId].titles.resultList || CT.cache.homeTitle

        if (refresh) newSearchFlow(params, refresh)
        else $resContainer.trigger('results_scroll');
      } else {// if the container isnt present , call newSearchFlow 
        newSearchFlow(paramsHash);
      }
    }


    var isMulticity = window.location.href.indexOf("from1") > -1
    $(".modify.searchBox")[!isMulticity ? 'show' : 'hide']();
    try {
      // direct url call (page onload with results url)
      if (!routesData) {
        if ((tmp = CT.settings.routes.checkUrlForIE()).toReplace) { // for IE with hashchange supported browser
          if (tmp.newUrl.indexOf("?ui=v3&") != -1) { // this is a hack to fix the redirect-url which is formed by the AB tool, this code can be removed after turning off the A/B test.

            var sptArray = tmp.newUrl.split("#");
            if (sptArray[0].indexOf("ui=v3") == -1) {
              sptArray[0] = sptArray[0] + "?ui=v3"
              sptArray[1] = sptArray[1].replace("ui=v3&", "");
              tmp.newUrl = sptArray.join("#");
            }
          }
          window.location.href = tmp.newUrl;
          return;
        }
        routesData = cleanRoutesData();
        CT.utils.showActiveCurrMenu();
        if (window.location.pathname.indexOf('international') > -1) routesData.intl = 'y';
      }
      //if flow is from search (home/modify) form
      if (!routesData || (routesData && !routesData.isPopped)) newSearchFlow(CT.settings.routes.cleanURLParams(routesData));
      // else if the flow is from browser history 
      else {
        routesData = cleanRoutesData();
        existingSearchFlow(routesData);
      }
      if (window.countryCode == "sa") {
        //GA Tag Manager Object
        dataLayer = CT.settings.GATagManager;

        dataLayer[0]['From-Location'] = routesData['from'];
        dataLayer[0]['To-Location'] = routesData['to'];
        dataLayer[0]['Travel-Dates'] = routesData['depart_date'] + (routesData['return_date'] ? '|' + routesData['return_date'] : "");
        dataLayer[0]['People-No'] = routesData['adults'] + '|' + routesData['childs'] + '|' + routesData['infants'];
        dataLayer[0]['Date-Search'] = moment().format("DD/MM/YYYY");
        dataLayer[0]['Day-Search'] = moment().format("dddd");
        dataLayer[0]['Product'] = "Air";
        dataLayer[0]['Device'] = "Desktop";
        dataLayer[0]['Travel-Type'] = routesData['intl'] == "n" ? "Domestic" : "International";
      }
      CT.utils.helperFunctions.storeUserReferer();
      CT.widgets.placeholder.parseDomTree(this.$el);

    } catch (e) {
      //TODO handle error cases where parameters are mismatching. (status-400)
    }
  } // search method ends




  /* 	=================== Adding subscriptions  =================== */
  CT.subscribe('results.old', function (data, tabId) {
    var params = !data.url ? _.serialize(data) : data.url
    CT.settings.routes.navigate(getPathName(data) + params, { trigger: false })
    $('.resultContainer').hide()
    $('#ResultContainer_' + tabId).css('display', 'block').trigger('results_scroll')
    document.title = CT.cache[tabId].titles.resultList
    //setMouseFlowPage(getPathName(data) + params)
  })

  // Called from the search forms!
  CT.subscribe('url.update', function (data) {
    var routes = CT.settings.routes
    // Carry forward the SEM paramters to SRP.
    CT.utils.helperFunctions.getSEMParams(window.location.search.substring(1), data);
    var urlData = routes.cleanURLParams($.extend({}, data))
    urlData = routes.cleanURLParams($.extend({}, data), ['ver', 'type', 'trip_type', 'srpDepartDate', 'srpReturnDate'])
    urlData = routes.cleanURLParams(urlData, function () {
      _.each(this, function (val, key, obj) {
        if (/origin|destination/.test(key)) delete obj[key]
      })
    })
    var pers = new Pers();
    var currentTime = new Date().getTime();
    if (CT.settings[CT.app].filterApplied) {
      var recentPers = pers.get('filter_applied');
      if (recentPers && recentPers.length > 0) {
        var fList = _.filter(recentPers, function (arr, idx) { return arr.from === urlData.from && arr.to === urlData.to });
        if (fList.length > 0 && ((currentTime - fList[0].timestamp) < (1000 * 60 * 60 * 24))) {
          $.extend(urlData, fList[0]);
        }
      }
    }

    var url = _.serialize(urlData), tmp

    if (window.isMarketingPage === true) {
      var loc = window.location
      window.location.href = "http:" + '//' + loc.hostname + "/flights" + getPathName(urlData) + url
    } else if (($.browser.msie && parseInt($.browser.version, 10) <= 8)) { // For IE-7 and 8 reload the results page
      var loc = window.location
      var _url = "http:" + '//' + loc.host + loc.pathname + getPathName(urlData) + url
      _url = routes.__fix(routes.getPathname(_url))
      if (window.location.href == _url) {
        window.location.reload()
      } else {
        window.location.assign(_url);
      }
    } else {
      if ($.browser.msie && $.browser.version == "9.0"
        && window.location.hash == unescape("#" + getPathName(urlData) + url)) {
        window.location.reload(); //if the modify search params are same as the browser url params , the hash change will not get triggered for IE 9, so we are manually reload the page 
      } else if (navigator.userAgent.indexOf("iPad") != -1) {
        var loc = window.location
        window.location.href = "http:" + '//' + loc.hostname + "/flights" + getPathName(urlData) + url
      } else {
        //for pgfee vmo test submitting the form.
        if (CT.settings[CT.app].runVmoTesting && urlData.intl && urlData.intl === 'y') {
          var loc = window.location;
          var _url = "http:" + '//' + loc.hostname + getFullPathName(urlData) + url
          window.location.href = _url;
        } else {
          return routes.navigate(getPathName(urlData) + url, data)
        }
      }

    }

    //searchModify.render();
  })

  // Called when the filters/sorters are updated
  CT.subscribe('url.update.filters', function (fltdata) {
    CT.settings.routes.navigate(getPathName(fltdata) + _.serialize(fltdata), { trigger: false, replace: true })
  })



  /*==================================  APP LEVEL SUBSCRIPTIONS  ==================================*/

  CT.subscribe('viewFlags.update', function (newflags) {
    CT.cache[CT.settings.currentTab].flags = $.extend(true, CT.cache[CT.settings.currentTab].flags, newflags);
  });

  CT.subscribe("flashsale.click", function () {
    CT.utils.helperFunctions.tpTrack({
      tp: 'clevertap',//Important,
      category: 'Air_UI_Action',
      values: {
        'last_event_type': -1,
        'last_page_name': -1,
        'current_page': 'flights_home',
        'action_type': 'Link',
        'action_name': 'FlashSale_Message',
        'is_logged_in': CT.utils.readCTAuthCookie() ? 'yes' : 'no',
        'source': 'web'
      }
    })
  });

  $(document).delegate("#flightShortlistCountDisplay a", "click", function () {
    CT.utils.helperFunctions.tpTrack({
      tp: 'clevertap',//Important,
      category: 'Air_UI_Action',
      values: {
        action_type: 'Click',
        action_name: 'Shortlistpage_entry',
        current_page: 'flights_home',
      }
    })
  })

	/*CT.subscribe('loadResults', function(paramsHash){ 
		loadResultsPage(paramsHash);
	});*/

  /* ======================= MODULE EXECUTION STARTS HERE =========================== */


  // Set some things when the page is getting ready
  if (!$.isReady) $(preInit)
  else preInit()
	/**
	 *  Setting up the app with routes
	 */



  var routesMap = {
    '': ['home', init],

    '/ar': ['home', init],

    '/?:params': ['home', init],

    '/ar?:params': ['home', init],

    '/local': ['home', init],

    '/results?:params': ['search', search],

    '/international/results?:params': ['search', search]

  };

  if (window.isMarketingPage === true) {
    // Routes are dynamic so as in near future it will automatically pick the url( window.loaction.path) of marketing pages.
    routesMap[window.location.pathname] = ['home', init];
  }

  var routes = (CT.settings.routes = new Routes((window.CT.langUrlPrefix ? window.CT.langUrlPrefix : "") + '/flights').add(routesMap))
  //>>excludeStart("devCode", pragmas.devCode);

  if (typeof (preCT) !== 'undefined') {
    preCT.destroy();
  }
  //.start() started outside index.js (in config.js in devMode whereas in html in prodMode)
  //>>excludeEnd("devCode");
})
;
